import React from "react";
import { Component } from "react";
import { notify } from "react-notify-toast";
import DeletePopup from "./ConfirmationBox";
import { connect } from "react-redux";
import "react-datepicker/dist/react-datepicker.css";
import "./UserProfile.css";
import {
  handleLogErrorToSlack,
  LIST_PAY_LEVEL_EVIDENCES,
  TEACHING_QUAL_AUSTRALIA_WITH_EXP,
  TEACHING_QUAL_AUSTRALIA_NO_EXP,
  TEACHING_QUAL_OVERSEAS_WITH_EXP,
  TEACHING_QUAL_OVERSEAS_NO_EXP,
  getPresumedLevelName,
  levelOptions,
} from "../../Helper";
import FormDropdown from "../../Components/FormField/FormDropdown";
import FormField from "../../Components/FormField/FormField";
import HoverIcon from "../../Components/FormField/HoverIcon-nova";
import { API } from "../../API";
import { CircularProgress } from "@mui/material";

const uploadingFileType = {
  PAYSLIP: "payslip",
  LETTER: "letter",
}

export class PayLevel extends Component {
  constructor(props) {
    super(props);

    if (!this.props.user) {
      window.location = "/login";
    }

    this.state = {
      deletePayslipPopup: false,
      deleteLetterPopup: false,
      uploadingType: "",
      filetype: true,
      file: null,
      preview: null,
      show: false,
      borderRadius: 0,
      width: 300,
      height: 200,
      scale: 1,
      image: "",
      allowZoomOut: false,
      showPopup: false,
    };
  }

  uploadDocument = (id) => {
    document.getElementById(id).click();
  };

  handlePayslipFileChange = () => {
    var isValidFile = false;
    let payslipFile = this.uploadPayslip.files[0];

    isValidFile = this.validateFile(payslipFile);
    if (isValidFile) {
      this.setState({
        image: payslipFile,
        showPopup: true,
      });
      this.saveFile(payslipFile, 'payslip', uploadingFileType.PAYSLIP);
    }
  };

  handleLetterFileChange = () => {
    var isValidFile = false;
    let letterFile = this.uploadLetter.files[0];

    isValidFile = this.validateFile(letterFile);
    if (isValidFile) {
      this.setState({
        image: letterFile,
        showPopup: true,
      });
      this.saveFile(letterFile, 'letter', uploadingFileType.LETTER);
    }
  };

  validateFile = (file) => {
    let isValid = false;
    if (file !== null && file !== undefined) {
      isValid = true;
    }
    return isValid;
  };

  deleteFile = (isDelete, fileName, popupStatus, fileType) => {
    var popUpState = "delete" + fileName + "Popup";
    if (isDelete) {
      notify.show("File deleted successfully");

      switch (fileType) {
        case uploadingFileType.PAYSLIP:
          this.props.handleStateChange("payslip_filename", null);
          this.props.handleStateChange("payslip_url", null);
          break;
        case uploadingFileType.LETTER:
          this.props.handleStateChange("letter_filename", null);
          this.props.handleStateChange("letter_url", null);
          break;
      }
    }
    this.setState({ [popUpState]: popupStatus });
  };

  onFileUpload = (fileName, url, fileType) => {
    switch (fileType) {
      case uploadingFileType.PAYSLIP:
        this.props.handleStateChange("payslip_filename", fileName);
        this.props.handleStateChange("payslip_url", url);
        break;
      case uploadingFileType.LETTER:

        this.props.handleStateChange("letter_filename", fileName);
        this.props.handleStateChange("letter_url", url);
        break;
    }
  };

  saveFile = async (file, fileName, fileType) => {
    this.setState({
      isLoading: true,
      uploadingType: fileType
    });

    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("fileName", `${fileName}`)
      const response = await API.uploadCompressedFileToS3(formData)
  
      const url = response?.data?.data
      const cut_length = "https://platform-backend-files.s3.amazonaws.com/".length;
      const suffix = url.substring(cut_length, url.length);
      const prefix = "https://zps3crms67.execute-api.ap-southeast-2.amazonaws.com/default/getfile3?path=";
      const new_url = prefix + suffix;
      this.onFileUpload(file.name, new_url, fileType);
      this.setState({
        isLoading: false,
        uploadingType: ""
      });
    } catch (error) {
      this.setState({
        isLoading: false,
        uploadingType: ""
      });
      handleLogErrorToSlack(error, true);
      notify.show(JSON.stringify(error), "error");
    }
  };

  togglePopup = () => {
    this.setState({ showPopup: !this.state.showPopup });
  };

  checkPayLevelUploaded = () => {
    return this.props.state?.status === "uploaded";
  }

  render() {
    return (
      <div className="row">
        <div className="col-md-12">
          <p className="font-weight-bold mb-2">
            Important information about our pay system
          </p>
          <p className="mb-3">
            ReadyTeacher classifies ten (10) Australian pay levels into four (4) categories for the purposes 
            of simplifying the classification process and getting you working faster.
          </p>
          <div className="auth-text-top mb-2 custom-dropdown">
            <FormDropdown
              label="Please choose the option that best describes you:"
              id="category_name"
              name="category_name"
              onChange={this.props.handleFormFieldChange}
              value={this.props.state?.category_name || ""}
              required
              disabled={this.checkPayLevelUploaded()}
            >
              <option disabled value="">
                Please Select
              </option>
              {
                LIST_PAY_LEVEL_EVIDENCES.map((payLevel) => {
                  return <option key={payLevel}>{payLevel}</option>;
                })
              }
            </FormDropdown>

            {
              this.props.state?.category_name === TEACHING_QUAL_AUSTRALIA_WITH_EXP && (
                <>
                  <p className="font-weight-bold mb-2">
                    Please upload one (1) recent payslip from your current or most recent college employer.
                    The payslip must display your hourly rate or pay scale/level according to the Award. 
                  </p>
                  <FormDropdown
                    label="Select your presumed level of pay:"
                    id="presumed_level_number"
                    name="presumed_level_number"
                    onChange={this.props.handleFormFieldChange}
                    value={this.props.state.presumed_level_number ?? ""}
                    required
                    disabled={this.checkPayLevelUploaded()}
                  >
                    <option disabled value="">
                      Please Select
                    </option>
                    {levelOptions.map((presumed_level) => {
                      return <option key={presumed_level.value} value={presumed_level.value}>
                        {presumed_level.value !== 0 ? `Level ${presumed_level.value} (${presumed_level.rate}$)` : "Unknown"}
                      </option>;
                    })}
                  </FormDropdown>
                  <FormField
                    label="Upload Your Payslip"
                    id="payslip_upload"
                    name="payslip"
                    disabled
                    required
                    placeholder={
                      this.props.state.payslip_filename ||
                      "Upload your PDF, PNG, or JPG payslip copy"
                    }
                    header={
                      <>
                        {this.state.status ? (
                          <HoverIcon
                            icon="check circle"
                            color="green"
                            text="This document has been verified!"
                          />
                        ) : (
                          <HoverIcon
                            icon="check circle"
                            color="grey"
                            text="This document has not been verified yet!"
                          />
                        )}
                        <HoverIcon
                          icon="info circle"
                          color="grey"
                          text="Please upload a file less than 600KB."
                        />
                      </>
                    }
                    sideButton={{
                      id: "btnUpload_payslip",
                      label: "Upload",
                      type: "button",
                      onClick: () => this.uploadDocument("payslip"),
                      disabled: this.props.state.payslip_url || this.state.isLoading || this.checkPayLevelUploaded(),
                    }}
                    footer={
                      this.props.state?.payslip_filename ? (
                        <div className="text-left d-flex">
                          <a href={`/NavigateToFileViewer?fileurl=${this.props.state?.payslip_url}`} target='_blank'>
                            <p className="uploaded-file-name mt-1 ml-1">
                              {this.props.state?.payslip_filename}
                            </p>
                          </a>
                          <i
                            className="mdi mdi-delete-circle d-flex mt-1 ml-1 uploaded-file-delete-icon"
                            onClick={() => this.setState({ deletePayslipPopup: true })}
                          ></i>
                          {this.state.deletePayslipPopup && (
                            <DeletePopup
                              togglePopup={(isDelete) =>
                                this.deleteFile(isDelete, "Payslip", false, uploadingFileType.PAYSLIP)
                              }
                            />
                          )}
                        </div>
                      ) : (
                        ""
                      )
                    }
                  >
                    {
                      this.state.isLoading && this.state.uploadingType === uploadingFileType.PAYSLIP && (
                        <CircularProgress />
                      )
                    }
                    <input
                      type="file"
                      id="payslip"
                      name="payslip"
                      onChange={() => this.handlePayslipFileChange()}
                      ref={(ref) => {
                        this.uploadPayslip = ref;
                      }}
                      style={{ display: "none" }}
                      accept="image/*, .pdf"
                    />
                  </FormField>
                  {
                    (this.props.state.presumed_level_number ?? -1) >= 0  && this.props.state.payslip_url && (
                      <p className="font-weight-bold mb-2">
                        Your presumed category is {getPresumedLevelName(+this.props.state.presumed_level_number)}. This will be confirmed shortly by our team.
                      </p>
                    )
                  }
                </>
              )
            }
          </div>
          {
            (this.props.state?.category_name === TEACHING_QUAL_AUSTRALIA_NO_EXP || this.props.state?.category_name === TEACHING_QUAL_OVERSEAS_NO_EXP) && (
              <p className="font-weight-bold mb-2">
                Your level is Junior. You will progress to Senior after 2 years of work experience sector-wide or 1,400 hours at ReadyTeacher.
              </p>
            )
          }

          {
            this.props.state?.category_name === TEACHING_QUAL_OVERSEAS_WITH_EXP && (
              <>
                <p className="font-weight-bold mb-2">
                  Please upload one letter from your previous college employer. 
                  The letter should show your completed teaching in months and years and indicate if you have taught adults or young learners.
                </p>
                {/* Letter 1 */}
                <FormField
                  label="Upload Your Letter"
                  id="letter_upload"
                  name="letter"
                  disabled
                  required
                  placeholder={
                    this.props.state.letter_filename ||
                    "Upload your PDF, PNG, or JPG payslip copy"
                  }
                  header={
                    <>
                      {this.state.status ? (
                        <HoverIcon
                          icon="check circle"
                          color="green"
                          text="This document has been verified!"
                        />
                      ) : (
                        <HoverIcon
                          icon="check circle"
                          color="grey"
                          text="This document has not been verified yet!"
                        />
                      )}
                    </>
                  }
                  sideButton={{
                    id: "btnUpload_letter",
                    label: "Upload",
                    type: "button",
                    onClick: () => this.uploadDocument("letter"),
                    disabled: this.props.state?.letter_url || this.state.isLoading || this.checkPayLevelUploaded(),
                  }}
                  footer={
                    this.props.state?.letter_filename ? (
                      <div className="text-left d-flex">
                        <a href={`/NavigateToFileViewer?fileurl=${this.props.state?.letter_url}`} target='_blank'>
                          <p className="uploaded-file-name mt-1 ml-1">
                            {this.props.state?.letter_filename}
                          </p>
                        </a>
                        <i
                          className="mdi mdi-delete-circle d-flex mt-1 ml-1 uploaded-file-delete-icon"
                          onClick={() => this.setState({ deleteLetterPopup: true })}
                        ></i>
                        {this.state.deleteLetterPopup && (
                          <DeletePopup
                            togglePopup={(isDelete) =>
                              this.deleteFile(isDelete, "Letter", false, uploadingFileType.LETTER)
                            }
                          />
                        )}
                      </div>
                    ) : (
                      ""
                    )
                  }
                >
                  {
                    this.state.isLoading && this.state.uploadingType === uploadingFileType.LETTER && (
                      <CircularProgress />
                    )
                  }
                  <input
                    type="file"
                    id="letter"
                    name="letter"
                    onChange={() => this.handleLetterFileChange()}
                    ref={(ref) => {
                      this.uploadLetter = ref;
                    }}
                    style={{ display: "none" }}
                    accept="image/*, .pdf"
                  />
                </FormField>

                {
                  this.props.state?.letter_url && (
                    <p className="font-weight-bold mb-2">
                      Your presumed category will be confirmed shortly by our team.
                    </p>
                  )
                }
              </>
            )
          }

          {
            !this.checkPayLevelUploaded() && (
              <p className="font-weight-bold mb-2">
                Please press submit to continue.
              </p>
            )
          }
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    user: state.user.user,
  };
};
export default connect(mapStateToProps)(PayLevel);
